import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';
// import stagedPurchases, {
//   setStagedPurchases,
//   removeStagedPurchase,
//   addStagedPurchases,
//   adjustStagedPurchaseQuantity,
//   addStagedPurchase,
// } from './stagedPurchases';

const initialState = {
  offerId: null as string | null,
  purchaseId: null as string | null,
  userAdded: false,
  hash: null as string | null,
};

const slice = createSlice({
  name: '$selectedOffer',
  initialState,
  reducers: {
    setSelectedOffer: (
      state,
      action: PayloadAction<{
        offerId: string | null;
        purchaseId?: string;
        userAdded: boolean;
        hash?: string;
      } | null>,
    ) => {
      return !action.payload
        ? initialState
        : {
            offerId: action.payload.offerId,
            purchaseId: action.payload.purchaseId ?? null,
            userAdded: action.payload.userAdded,
            hash: action.payload.hash ?? null,
          };
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, (_state, _action) => {
      return initialState;
    });
    // .addMatcher(
    //   isAnyOf(
    //     setStagedPurchases,
    //     removeStagedPurchase,
    //     addStagedPurchase,
    //     addStagedPurchases,
    //     adjustStagedPurchaseQuantity,
    //   ),
    //   (state, action) => {
    //     return state;
    //   },
    // );
  },
});

export const { setSelectedOffer } = slice.actions;
export default slice.reducer;
